import React from "react";
import styles from "./Input.module.scss";

const Toggle = ({
  isActive,
  onChange,
  text,
  color = "red",
  errors,
  touched,
  /**
   * Accessible name for the switch.
   *
   * ⚠ WITHOUT IT THIS CONTROL HAS NO NAME. `text` renders in an `<h4>` OUTSIDE
   * the `<label>`, so it labels nothing — a screen reader announces every one
   * of these as an unnamed checkbox. Additive and optional: every existing
   * call site omits it and behaves exactly as before, and a new screen can
   * pass a real name. Pass it wherever `text` is empty, which is where the
   * control has no visible label at all.
   */
  ariaLabel,
}) => {
  return (
    <div className={styles["toggle-container"]}>
      <label className={styles["switch"]}>
        <input
          type='checkbox'
          checked={isActive}
          onChange={onChange}
          aria-label={ariaLabel || undefined}
        />
        <span
          className={
            "blue" === color ? styles["slider-blue"] : styles["slider"]
          }
        ></span>
      </label>

      <h4 style={{ color: errors && touched ? "#f3223c" : "" }}>{text}</h4>
    </div>
  );
};

export default Toggle;
